import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GeneralRoutingModule } from './general-routing.module';
import { SharedModule } from '../../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbNavModule, NgbDropdownModule, NgbPaginationModule, NgbHighlight } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
// import { DataTablesModule } from 'angular-datatables';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { AgGridModule } from 'ag-grid-angular';

import { LocationComponent } from 'src/app/components/shared/location/location.component';

import { ListAddressbookComponent } from 'src/app/components/setup/general/addressbook/list/listaddressbook.component';
import { AddAddressbookComponent } from 'src/app/components/setup/general/addressbook/add/addaddressbook.component';
import { EditAddressbookComponent } from 'src/app/components/setup/general/addressbook/edit/editaddressbook.component';

import { ShipperService } from 'src/app/services/general/shipper.service'; 
import { ConsigneeService } from 'src/app/services/general/consignee.service'; 
import { AddressBookService } from 'src/app/services/general/addressbook.service'; 

@NgModule({
  declarations: [
    ListAddressbookComponent,
    AddAddressbookComponent,
    EditAddressbookComponent,
  ],
  imports: [
    CommonModule,
    GeneralRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    NgbHighlight,
    NgbNavModule,
    NgbDropdownModule,
    NgSelectModule,
    // DataTablesModule,
    NgbPaginationModule,
    CKEditorModule,
    AgGridModule,
  ],
  exports: [
    ListAddressbookComponent,
    AddAddressbookComponent,
    EditAddressbookComponent,

    LocationComponent,
  ],
  providers: [
    ShipperService,
    ConsigneeService,
    AddressBookService,
  ]
})
export class GeneralModule { }
